import { useEffect } from "react";
import Layout from "../components/Layout"
import Services from "../components/Services"
import "./styles.scss"

const Servicios = () => {
    useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
    return (
        <Layout actualPage="servicios">
            <div id="servicios">
                <Services/>
            </div>
        </Layout>
    )
}

export default Servicios